import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";



const CreateContactsCost = () => {
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [perContactsCost, setPerContactCost] = useState();
    // const [contactsPrice,setContactsPrice] = useState('');
    const [totalContacts, setTotalContacts] = useState();
    const [contactsRangeOpen, setContactsRangeOpen] = useState(false);
    const [contactsCostOpen, setContactsCostOpen] = useState(false);

    // const Navigate = useNavigate();

    const buyContactsApi = () => {
        console.log(perContactsCost, totalContacts);
        let total_cost = perContactsCost*totalContacts; 
        Axios
            .post("api/bussiness/create-contacts-cost", {
                total_contacts: totalContacts,
                cost_per_contacts: perContactsCost,
                total_cost:total_cost,
            })
            .then((response) => {
                console.log(response);
                setNotify({
                    isOpen: true,
                    messsage: "Created Successfully",
                    type: 'success'
                })
            }).catch((error) => {
                // setNotify({
                //     isOpen: true,
                //     messsage: "already exits service",
                //     type: 'warning'
                // })
            });

    }




    const setContactsRangeFunc = async (e) => {
        if (e.target.value > 5000000) {
            setTotalContacts(5000000);
            setContactsRangeOpen(true);
        }
        if (e.target.value < 0) {
            setTotalContacts(0);
        }
        if (e.target.value >= 0 && e.target.value <= 5000000) {
            setTotalContacts(e.target.value);
        }
    }

    const contactsPerCostFunc = async (e) => {
        if (e.target.value > 10) {
            setPerContactCost(10);
            setContactsCostOpen(true);
        }
        if (e.target.value < 0) {
            setPerContactCost(0);
        }
        if (e.target.value >= 0 && e.target.value <= 10) {
            setPerContactCost(e.target.value);
        }

    }





    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                         <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Contacts Cost</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card-box" style={{ width: "50%",marginTop:"10px"}}>
                                <div className="form-group mb-3">
                                    <label htmlFor="NoOfmessage">Contacts Range</label>
                                    <input
                                        onChange={(e) => setContactsRangeFunc(e)}
                                        id="NoOfmessage"
                                        value={totalContacts}
                                        min="0"
                                        type="Number"
                                        className="form-control"
                                        placeholder="Enter Contacts Number"
                                    />
                                </div>
                                {contactsRangeOpen ? <h8 style={{ color: 'Red' }}>Can not buy More than 50,00,000</h8> : ""}


                                <div className="form-group mb-3">
                                    <label htmlFor="NoOfmessage">Cost Per Contacts</label>
                                    <input
                                        onChange={(e) => contactsPerCostFunc(e)}
                                        id="NoOfmessage"
                                        value={perContactsCost}
                                        min="0"
                                        max="10"
                                        type="Number"
                                        className="form-control"
                                        placeholder="Enter cost per contacts in rupees"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="NoOfmessage">Total Cost</label>
                                    <input
                                        disabled
                                        id="NoOfmessage"
                                        value={perContactsCost*totalContacts }
                                        min="0"
                                        max="10"
                                        type="Number"
                                        className="form-control"
                                        placeholder="Enter cost per contacts in rupees"
                                    />
                                </div>
                                {contactsCostOpen ? <h8 style={{ color: 'Red' }}>Maximum Cost 10 Rupees per Contacts</h8> : ""}
                                <button onClick={buyContactsApi} className="btn btn-gradient btn-block" type="submit"> Submit </button>
                        
                                {
                                    notify.isOpen ?
                                        <Notification
                                            notify={notify}
                                            setNotify={setNotify} />
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateContactsCost;